<template>
  <div>
    <div class="head_main_wrap">
      <div class="head_bar">
        <div class="main_title">
          <router-link to="/home">{{ pageData.title }}</router-link>
        </div>
        <div class="items">
          <div class="username_content">
            {{ $t('App.text.hi') }} {{ pageData.username }}
          </div>
          <div>
            <el-popover
              placement="bottom"
              trigger="hover"
              width="180"
              :content="$t('App.notify.span_no_notification')"
            >
              <i
                class="el-icon-message-solid"
                style="font-size: 1.1rem; color: #ffffff"
                slot="reference"
              ></i>
            </el-popover>
          </div>
          <div class="avatar_content">
            <el-dropdown placement="bottom" :show-timeout="100">
              <el-avatar :size="30">{{ pageData.username }}</el-avatar>
              <el-dropdown-menu slot="dropdown">
                <div class="avatar_dropdown_items_content">
                  <el-dropdown-item
                    ><router-link to="/center">{{
                      $t('App.view.custCommonHead.router_custhome')
                    }}</router-link></el-dropdown-item
                  >
                  <el-dropdown-item>
                    <router-link to="/cart">{{
                      $t('App.view.custCommonHead.router_cart')
                    }}</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item disabled>About</el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/login" @click.native="custLogout">{{
                      $t('App.view.custCommonHead.router_logout')
                    }}</router-link></el-dropdown-item
                  >
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="notice_content">
        <el-alert
          :title="$t('App.view.custCommonHead.head_notice')"
          type="warning"
          :closable="false"
          show-icon
          effect="dark"
        ></el-alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shown: {},
      pageData: {
        username: '',
        title: '',
      },
      formData: {},
    }
  },
  mounted() {
    this.pageData.username = sessionStorage.getItem('username')
    this.pageData.title = sessionStorage.getItem('brand_title')
  },
  beforeDestroy() {},
  methods: {
    custLogout() {
      sessionStorage.clear()
      console.log('退出登录')

      this.router.push({ path: '/login' })
    },
  },
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: white;
}
.router-link-active {
  text-decoration: none;
  color: white;
}
.head_main_wrap {
  width: 100%;
}
.head_bar {
  z-index: 999;
  color: white;
  background-color: #323233;
  margin-bottom: 3rem;
  width: 100%;
  height: 4.5rem;
}
.notice_content {
  display: none;
  position: fixed;
  top: 4.5rem;
  left: 0;
  right: 0;
}
.main_title {
  padding-left: 2.5rem;
  line-height: 3.1;
  font-weight: normal;
  font-size: 1.4rem;
  display: table-cell;
  vertical-align: middle;
  width: 100%;
  text-align: left;
}
.items {
  padding-right: 1rem;
  font-size: 1rem;
  display: table-cell;
  vertical-align: middle;
}
.items div {
  display: table-cell;
  vertical-align: middle;
  padding-left: 0.5rem;
}
.username_content {
  font-size: 0.9rem;
}
.avatar_content {
  user-select: none;
}
.avatar_dropdown_items_content a {
  text-decoration: none;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/customerCommonHeader.vue